import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { ThemeProvider } from '@/contexts/theme-context'
import { HelmetProvider } from 'react-helmet-async'
import { Toaster } from 'sonner'
import { ScrollToTop } from '@/components/ScrollToTop'
import { HomePage } from '@/pages/home'
import { AboutPage } from '@/pages/about'
import { ServicesPage } from '@/pages/services'
import { BookAppointmentPage } from '@/pages/book-appointment'
import { GalleryPage } from '@/pages/gallery'
import { TestimonialsPage } from '@/pages/testimonials'
import { ContactPage } from '@/pages/contact'
import { BlogPage } from '@/pages/blog'
import { PrivacyPolicyPage } from '@/pages/privacy-policy'
import { TermsOfUsePage } from '@/pages/terms-of-use'
import { WelcomePage } from '@/pages/welcome'
import { FloatingWhatsApp } from '@/components/floating-whatsapp'

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/about" element={<AboutPage />} />
      <Route path="/services" element={<ServicesPage />} />
      <Route path="/book-appointment" element={<BookAppointmentPage />} />
      <Route path="/gallery" element={<GalleryPage />} />
      <Route path="/testimonials" element={<TestimonialsPage />} />
      <Route path="/contact" element={<ContactPage />} />
      <Route path="/blog" element={<BlogPage />} />
      <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
      <Route path="/terms-of-use" element={<TermsOfUsePage />} />
      <Route path="/welcome" element={<WelcomePage />} />
    </Routes>
  )
}

function App() {
  return (
    <HelmetProvider>
      <ThemeProvider defaultTheme="system" storageKey="boilerplate-theme">
        <Router>
          <ScrollToTop />
          <AppRoutes />
          <FloatingWhatsApp />
          <Toaster />
        </Router>
      </ThemeProvider>
    </HelmetProvider>
  )
}

export default App
